enum TabRegion {
    FundType = 'fundType',
    Module = 'module',
    Chart = 'chart',
    MobileFundCard = 'mobileFundCard',
}

export default TabRegion;



// WEBPACK FOOTER //
// ./src/models/components/TabRegion.ts